import type { CSSProperties } from 'react'

/** Seconds to wait after crossing the line before the rise starts. Keep in sync with `--reveal-wait`. */
export const REVEAL_WAIT = 0.2

/** Fade in when the top of the element reaches this fraction of the viewport. */
export const REVEAL_LINE = 0.86

export function revealRootMargin() {
  return `0px 0px -${(1 - REVEAL_LINE) * 100}% 0px`
}

export function revealDelay(seconds: number): CSSProperties {
  return { '--reveal-delay': `${seconds}s` } as CSSProperties
}
